import React from "react"
import PropTypes from "prop-types"

const EventCell = ({timestamp, event, isSdAdmin, onEventClicked}) => {
  const style = {
    backgroundColor: event.color,
    color: event.text
  }
  if (!isSdAdmin && event.open) {
    event.klass = event.klass.replace(/event_with_note/g, '')
  }
  const className = `reservation-clickable-cell ${event.klass}`
  const colSpan = Math.floor(event.duration / 1800)

  const renderIcons = (event) => {
    const icons = event.icons
    const showNotes = !event.open || (event.open && isSdAdmin)
    const showIcons = !event.open || isSdAdmin

    return <div className='event-icons'>
      { icons.with_notes && showNotes && <i className='with-notes'></i> }
      { icons.confirmed && showIcons && <i className='fa fa-solid fa-check-circle'></i> }
      { icons.confirmed_wf && showIcons && <i className='fa fa-solid fa-check-circle blue'></i> }
      { icons.pre_booked && showIcons && <i className='fa fa-solid fa-check-circle purple'></i> }
    </div>
  }

  return (
    <td
      style={style}
      className={className}
      data-time={timestamp}
      data-id={event.id}
      colSpan={colSpan}
      onClick={() => onEventClicked(event) }
    >
      <div className="upper">
        <span>{event.title}</span>
        {renderIcons(event)}
        {event.open && (
          <slot>
            <br></br>
            <span style={{color: "#0d171385"}}>{event.players}</span>
          </slot>
        )}
      </div>
    </td>
  )
}

EventCell.propTypes = {
  timestamp: PropTypes.string,
  event: PropTypes.object,
  isSdAdmin: PropTypes.bool,
}

export default EventCell
